import { api } from "@/api/axios.ts";
import {
  ApiWorkflowFolder,
  ApiWorkflowFolderPayload,
} from "@/types/workflows/workflow-folder.types.ts";

export const apiWorkflowFolders = {
  getAll: (signal?: AbortSignal) => {
    return api.get<ApiWorkflowFolder[]>(`/api/v1/workflow-folders`, undefined, signal);
  },
  create: (payload: ApiWorkflowFolderPayload) => {
    return api.post<ApiWorkflowFolder>(`/api/v1/workflow-folders/create`, payload);
  },
  update: (id: number, payload: ApiWorkflowFolderPayload) => {
    return api.put<ApiWorkflowFolder>(`/api/v1/workflow-folders/${id}`, payload);
  },
  delete: (id: number) => {
    return api.delete(`/api/v1/workflow-folders/${id}`);
  },
};
